import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import StrukList from '@/views/StrukList'
import NewStruk from '@/views/NewStruk'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/setupstruk',
    name: 'setupstruk',
    component: StrukList
  },
  {
    path: '/setupstruk/new',
    name: 'newstruk',
    component: NewStruk
  },
  {
    path: '/setupstruk/edit/:id',
    name: 'editstruk',
    component: NewStruk
  }
]

const router = new VueRouter({
  routes
})

export default router
